<template>
  <div
    class="change-trip-status-popup"
    :style="{ transform: `translate(${isLangRtl ? '' : '-'}50%, -50%)` }"
  >
    <div class="block-1 pb-4 mb-4">
      <div class="title">{{ $t('change-status') }}</div>
      <div>
        <img
          :src="require('@/assets/images/icons/cross-icon.svg')"
          alt="cross-icon"
          height="12px"
          width="12px"
          style="cursor: pointer"
          @click.stop="$emit('closeModal')"
        />
      </div>
    </div>
    <form @submit.prevent="Submit">
      <div class="block-2 pb-4 mb-4">
        <b-alert :show="error && error.length ? true : false" variant="danger">
          <div v-if="Array.isArray(error)">
            <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
              {{ error_text }}
            </div>
          </div>
          <div v-else>
            <div v-html="error || '&nbsp;'"></div>
          </div>
        </b-alert>
        <div class="sub-title mb-2 d-flex">
          {{ $t('reservation') }} <span>&nbsp;#</span>{{ selected_id }}
        </div>
        <div class="label">{{ $t('reservation-status') }}</div>

        <b-form-radio-group
          v-model="selected_status"
          :options="statusOptions"
          name="status"
          plain
        ></b-form-radio-group>
      </div>

      <div class="row">
        <div class="col-10"></div>
        <div class="col-2">
          <base-button
            variant="primary"
            type="submit"
            :disabled="originSelectedStatus === selected_status"
          >
            {{ $t('save') }}
          </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import NewReservationService from '@/services/new-reservation.service'

export default {
  props: ['selected_id', 'event'],
  emits: ['closeModal', 'refreshData'],
  data() {
    return {
      radio_options: [
        { text: this.$t('quotation'), value: 'quotation' },
        { text: this.$t('sales-order'), value: 'sales-order' },
        { text: this.$t('canceled'), value: 'cancelled' },
      ],
      selected_status: null,
      journey_time: null,
      error: null,
      originSelectedStatus: null,
    }
  },
  computed: {
    statusOptions() {
      let statusOptions
      switch (this.originSelectedStatus) {
        case 'quotation': {
          statusOptions = this.radio_options
          break
        }
        case 'sales-order': {
          statusOptions = this.radio_options.filter((option) => option.value !== 'quotation')
          break
        }
        case 'cancelled': {
          statusOptions = this.radio_options.filter((option) => option.value === 'cancelled')
          break
        }
        case 'waiting-for-approval': {
          statusOptions = [{ text: this.$t('waiting-for-approval'), value: 'waiting-for-approval' }]
          statusOptions.push(...this.radio_options.filter((option) => option.value === 'cancelled'))
          break
        }
        default: {
          statusOptions = this.radio_options
        }
      }
      return statusOptions
    },
  },
  methods: {
    setValue(val, field) {
      this[field] = val
    },
    Submit() {
      this.loading = true
      this.error = null

      const data = {}

      data['reservationId'] = this.selected_id
      if (this.selected_status) data['status'] = this.selected_status

      NewReservationService.post(data, 'change-reservation')
        .then(() => {
          this.$emit('closeModal')
          this.$emit('refreshData')
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  created() {
    this.selected_status = this.event.type
    this.originSelectedStatus = this.event.type
  },
}
</script>

<style lang="scss" scoped>
.change-trip-status-popup {
  position: fixed;
  top: 50%;
  inset-inline-start: 60%;
  z-index: 24;
  min-width: 60vw;
  background: var(--color-01);
  border: 1px solid var(--color-14);
  box-shadow: 0px 12px 16px var(--color-38);
  border-radius: 10px;
  padding: 2rem 1rem;
  .block-1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--color-14);
    color: var(--color-17);
    .title {
      font-weight: 700;
      font-size: 24px;
    }
  }
  .block-2 {
    border-bottom: 1px solid var(--color-14);

    .sub-title {
      font-weight: 700;
      font-size: 16px;
      color: var(--color-23);
    }

    .label {
      font-size: 14px;
      color: var(--color-17);
      margin-bottom: 10px;
      font-weight: 700;
    }
  }
  .block-3 {
    border-bottom: 1px solid var(--color-23);
  }
}
</style>
